<template>
  <v-app>
    <NavBar
      v-if="
        $route.path != '/MainMenu' &&
        $route.path != '/Login' &&
        $route.path != '/MeetingRoomScreen' &&
        $route.path != '/CheckinMeeting'
      "
    />
    <NavbarMain v-if="$route.path == '/MainMenu'" />
    <v-content>
      <div id="grad" v-if="$route.path == '/MainMenu'">
        <router-view></router-view>
      </div>
      <div v-else>
        <router-view></router-view>
      </div>
    </v-content>
    <Footer v-if="$route.path != '/MeetingRoomScreen'" />
  </v-app>
</template>

<script>
import NavBar from "./components/NavBar";
import NavbarMain from "./components/NavbarMain";
import Footer from "./components/Footer";
export default {
  name: "App",
  components: {
    NavBar,
    NavbarMain,
    Footer,
  },
  
  mounted() {
    this.checkInterval = setInterval(() => {
      const token = this.$cookies.get("Token");
      if (token) {
        this.$store.dispatch("", { token }).catch(() => {});
      }
    }, 60 * 1000);
  },

  beforeDestroy() {
    if (this.checkInterval) clearInterval(this.checkInterval);
  },
};
</script>

<style>
@font-face {
  font-family: "Inter";
  src: local("Inter"), url(./assets/Font/Inter-VariableFont_opsz,wght.ttf);
}

.v-content__wrap {
  background-color: white;
  width: 100%;
  height: 100%;
}

@media only screen and (max-width: 959px) {
  .v-content__wrap {
    background-color: white;
    width: 80%;
  }
}
* {
  font-family: "Inter";
}

#app {
  color: #444444;
}

#grad {
    height: 200px;
    background: #78A3D4;
    background: -webkit-linear-gradient(#78A3D4, #FFF); 
    background: -o-linear-gradient(#78A3D4, #FFF);
    background: -moz-linear-gradient(#78A3D4, #FFF);
    background: linear-gradient(#78A3D4, #FFF);
}

::-webkit-scrollbar {
  display: none;
}
</style>
